import { getPrice, Mode } from '~services/business/pricing';
import { SavingsInfo } from './savings-info';
import { theme } from '~globalStyles';
import { Trans } from '@lingui/react';
import { YearlyInfo } from './yearly-info';
import AmountFormat from '~components/i18n/amount-format';
import styled from 'styled-components';
import { PricingPlanComponentsProps } from '~components/pricing/types';

type PricingPlanPriceProps = {
    hasSavings: boolean;
    isYearly: boolean;
    mode: Mode;
} & PricingPlanComponentsProps;

export const PricingPlanPrice = ({
    currency,
    hasSavings,
    isYearly,
    language,
    mode,
    tier,
}: PricingPlanPriceProps) => {
    return (
        <>
            <Price>
                <AmountFormat
                    noSign
                    amount={getPrice(tier, mode, currency)}
                    currencyEnum={currency}
                    language={language}
                />
                {mode === Mode.YEARLY && (
                    <>
                        {/* when yearly, shows small box with yearly savings */}
                        {hasSavings && (
                            <SavingsInfo
                                currency={currency}
                                language={language}
                                tier={tier}
                            />
                        )}
                        {isYearly && (
                            <YearlyInfo
                                currency={currency}
                                language={language}
                                mode={mode}
                                tier={tier}
                            />
                        )}
                    </>
                )}
            </Price>
            <PriceDescription>
                <Trans id="global.pricing.priceTable.premium.description" />
            </PriceDescription>
        </>
    );
};

const Price = styled.div`
    font-family: ${({ theme }) => theme.primaryFont};
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 45px;
    position: relative;
`;

const PriceDescription = styled.div`
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: ${theme.lightGrey};
`;
